import { ConfigProvider, ThemeConfig } from 'antd';
import { PropsWithChildren, useEffect, useState } from 'react';

import { useThemeDetector } from '@hook/style/theme-detector.hook';

import { Typography } from './common/typography';
import { DropdownStyle } from './global-style.app';
import { StyleConfigInterface } from './style.interfaces';
import { loadTheme } from './style.util';
import { StyledProvider } from './styled.provider';

const INITIAL_CONFIG: ThemeConfig = {
  hashed: false,
  token: Typography,
};

export const StyleApp = ({ children }: PropsWithChildren) => {
  const theme = useThemeDetector();
  const [config, setConfig] = useState<StyleConfigInterface>({
    ...INITIAL_CONFIG,
    ...loadTheme(theme),
  } as StyleConfigInterface);

  useEffect(() => setConfig({ ...INITIAL_CONFIG, ...loadTheme(theme) }), [theme]);

  return (
    <ConfigProvider theme={config}>
      <StyledProvider>
        <DropdownStyle />
        {children}
      </StyledProvider>
    </ConfigProvider>
  );
};
